import { useGlobalState } from '@/hooks';
import type { IPmtOnboardingPopup } from '@/modules/pmt/interfaces';
import { getMasterTranslationLanguageCode } from '@/utils';
import { getCurrentTextOfMultipleLanguageField } from '@/utils/text.utils';
import { Icon, PointTitle, PointWrapper, PropositionListWrapper } from './PropositionList.styles';
interface PropositionListProps {
  list: IPmtOnboardingPopup['joinUsValuePropositionList'];
}

export const PropositionList: React.FC<PropositionListProps> = ({ list }) => {
  const { pmtCurrentLanguageCode } = useGlobalState();
  const languageField = getMasterTranslationLanguageCode(pmtCurrentLanguageCode);

  if (!list?.length) return null;

  return (
    <PropositionListWrapper>
      {list?.map(({ id, icon, title }) => (
        <PointWrapper key={id}>
          <Icon src={icon?.url} alt={title} />
          <PointTitle>{title && getCurrentTextOfMultipleLanguageField(title, languageField)}</PointTitle>
        </PointWrapper>
      ))}
    </PropositionListWrapper>
  );
};
